import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { useClientTranslations } from "../../lib/i18n/client";
import type { LibraryCategory } from "../../services/educationService";
import styles from "./BrowseLibrary.module.css";
import { CategoryCard } from "./CategoryCard";

interface BrowseLibraryProps {
	items: LibraryCategory[];
}

export function BrowseLibrary({ items }: BrowseLibraryProps) {
	const { direction } = useClientTranslations("education");

	return (
		<div className={styles.container}>
			<Swiper
				modules={[Pagination]}
				slidesPerView="auto"
				spaceBetween={12}
				pagination={{ clickable: true }}
				dir={direction}
				threshold={10}
				touchStartPreventDefault={false}
				resistanceRatio={0.65}
				className={styles.swiper}
			>
				{items.map((item) => (
					<SwiperSlide key={item.id} className={styles.slide}>
						<CategoryCard category={item} />
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
}
